const whatsapp = (message, number = '') => {
  const url = 'whatsapp://send?phone=' +
    encodeURI(number) +
    '&text=' + encodeURIComponent(message)

  const a = document.createElement('a');
  a.href = url;
  a.style = 'display: none;';
  a['data-action'] = 'share/whatsapp/share';

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
};

const share = (message) => {
  if (typeof navigator.share === 'function') {
    navigator.share({
      text: message,
    });
  } else {
    whatsapp(message);
  }
};

export default {
  whatsapp,
  share,
};
